import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import ImageUploader from "Components/UI/ImageUploder";
import ImageCropper from "Components/UI/Image/ImageCropper";

const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const statusOptions = [
  { id: 1, label: "Active", value: "Active" },
  { id: 2, label: "Inactive", value: "Inactive" },
];

const InsuranceForm = () => {
  const {
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useFormContext();

  console.log("Render InsuranceForm", watch("attachment"));

  return (
    <div className="form-row row">
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="insuranceType"
          type="text"
          placeholder="Insurance Type"
          className={`form-control ${errors.insuranceType ? "is-invalid" : ""}`}
          label="Insurance Type"
          labelClassName="form-label"
          required={true}
          requiredMessage="Insurance Type is required"
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="policyNo"
          type="text"
          placeholder="Policy No"
          className={`form-control ${errors.policyNo ? "is-invalid" : ""}`}
          label="Policy No"
          labelClassName="form-label"
          required={true}
          requiredMessage="Policy No is required"
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="insurancePeriod"
          type="text"
          placeholder="Insurance Period"
          className={`form-control ${
            errors.insurancePeriod ? "is-invalid" : ""
          }`}
          label="Insurance Period"
          labelClassName="form-label"
          required={true}
          requiredMessage="Insurance Period is required"
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="startDate"
          type="date"
          placeholder="Start Date"
          className={`form-control ${errors.startDate ? "is-invalid" : ""}`}
          label="Start Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="Start Date is required"
          dateFormat="YYYY-MM-DD"
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="endDate"
          type="date"
          placeholder="End Date"
          className={`form-control ${errors.endDate ? "is-invalid" : ""}`}
          label="End Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="End Date is required"
          dateFormat="YYYY-MM-DD"
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="sumInsured"
          type="number"
          placeholder="Sum Insured"
          className={`form-control ${errors.sumInsured ? "is-invalid" : ""}`}
          label="Sum Insured"
          labelClassName="form-label"
          required={true}
          requiredMessage="Sum Insured is required"
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="class"
          type="text"
          placeholder="Class"
          className={`form-control ${errors.class ? "is-invalid" : ""}`}
          label="Class"
          labelClassName="form-label"
          required={false}
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="employeesList"
          type="text"
          placeholder="Employees List"
          className={`form-control ${errors.employeesList ? "is-invalid" : ""}`}
          label="Employees List"
          labelClassName="form-label"
          required={false}
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="purpose"
          type="text"
          placeholder="Purpose"
          className={`form-control ${errors.purpose ? "is-invalid" : ""}`}
          label="Purpose"
          labelClassName="form-label"
          required={false}
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="abbreviation"
          type="text"
          placeholder="Abbreviation"
          className={`form-control ${errors.abbreviation ? "is-invalid" : ""}`}
          label="Abbreviation"
          labelClassName="form-label"
          required={false}
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="responsibleBy"
          type="text"
          placeholder="Responsible By"
          className={`form-control ${errors.responsibleBy ? "is-invalid" : ""}`}
          label="Responsible By"
          labelClassName="form-label"
          required={true}
          requiredMessage="Responsible By is required"
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="vendorName"
          type="text"
          placeholder="Vendor Name"
          className={`form-control ${errors.vendorName ? "is-invalid" : ""}`}
          label="Vendor Name"
          labelClassName="form-label"
          required={true}
          requiredMessage="Vendor Name is required"
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="agencyName"
          type="text"
          placeholder="Agency Name"
          className={`form-control ${errors.agencyName ? "is-invalid" : ""}`}
          label="Agency Name"
          labelClassName="form-label"
          required={true}
          requiredMessage="Agency Name is required"
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="address"
          type="text"
          placeholder="Address"
          className={`form-control ${errors.address1 ? "is-invalid" : ""}`}
          label="Address"
          labelClassName="form-label"
          required={true}
          requiredMessage="Address is required"
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="contactNo"
          type="text"
          placeholder="Contact No"
          className={`form-control ${errors.contactNo ? "is-invalid" : ""}`}
          label="Contact No"
          labelClassName="form-label"
          required={true}
          requiredMessage="Contact No is required"
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="emailID"
          type="email"
          placeholder="Email ID"
          className={`form-control ${errors.emailID ? "is-invalid" : ""}`}
          label="Email ID"
          labelClassName="form-label"
          required={true}
          requiredMessage="Email ID is required"
          defaultValue=""
        />
      </div>
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="activeSince"
          type="text"
          placeholder="Active Since"
          className={`form-control ${errors.activeSince ? "is-invalid" : ""}`}
          label="Active Since"
          labelClassName="form-label"
          required={true}
          requiredMessage="Active Since is required"
          defaultValue=""
        />
      </div> */}

      {/* <div className="col-md-4 col-sg-12 mb-3">
        
        <Input
          name="status"
          type="commonSelect"
          placeholder="Status"
          className={`form-control select ${errors.status ? "is-invalid" : ""}`}
          label="Status"
          labelClassName="form-label"
          required={true}
          requiredMessage="Status is required"
          optionData={[
            { id: 1, label: "Active", value: "Active" },
            { id: 2, label: "Inactive", value: "Inactive" },
          ]}
          onChange={(option) => {
            setValue("status", option.value);
            trigger("status");
          }}
          defaultValue={watch("status")}
        />
      </div> */}
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder="Select Status"
          className={`form-control select ${
            errors.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3"></div>
      <div className="col-md-4 col-sg-12 mb-3">
        <ImageCropper
          setBase64Value={(file) => setValue("attachment", file)}
          base64Value={watch("attachment")}
        />

        {/* <Input
          name="attachment"
          type="text"
          placeholder="Attachment URL"
          className={`form-control ${errors.attachment ? "is-invalid" : ""}`}
          label="Attachment"
          labelClassName="form-label"
          required={true}
          requiredMessage="Attachment URL is required"
          defaultValue=""
        /> */}
      </div>
    </div>
  );
};

export default InsuranceForm;
